import { render, staticRenderFns } from "./modal-details.component.vue?vue&type=template&id=a4ff1432&scoped=true"
import script from "./modal-details.component.vue?vue&type=script&lang=js"
export * from "./modal-details.component.vue?vue&type=script&lang=js"
import style0 from "./modal-details.component.vue?vue&type=style&index=0&id=a4ff1432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff1432",
  null
  
)

export default component.exports